import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const PagerLoadMore = ({ currentPage, totalPages, setCurrentPage, onLoadMore }) => {
  const { t } = useTranslation();

  return (
    totalPages > 1 && currentPage < totalPages ? (
      <div className="PagerLoadMore">
        <a
          className="PagerLoadMore__button PagerLoadMore__icon Button Button--secondary"
          onClick={(e) => {
            e.preventDefault();
            onLoadMore();
          }}>
          <span>{t('components.pager_loadmore.load_more')}</span>
          <i className="icon icon-arrow-down" />
        </a>
      </div>
    ) : null
  );

};
export default PagerLoadMore;
